import React from 'react'

const SwapHorizontalIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={{ display: 'block' }}
    >
      <path
        d='M8.49711 1.71968L9.55777 2.78034L5.5862 6.75192L20.2514 6.77737L20.2488 8.27736L5.59004 8.25193L9.55777 12.2197L8.49711 13.2803L2.7168 7.50001L8.49711 1.71968Z'
        fill='#141414'
      />
      <path
        d='M21.3381 16.4678L15.555 10.7437L14.4998 11.8098L18.5076 15.7767L3.75011 15.7767L3.75011 17.2767L18.4267 17.2767L14.4944 21.2491L15.5604 22.3044L21.3381 16.4678Z'
        fill='#141414'
      />
    </svg>
  )
}

export default SwapHorizontalIcon
